<template>
  <div>
    <div @click="back"
        style="width: 100%;background: #fef2ce;margin-bottom: 20px;color: #e2781c;text-align: center;padding: 5px 0">
      本功能即将下架，请前往店员工作台首页。
    </div>


    <div class="earning" @click="pushWages">
      <div class="watch">
        <div class="watchClick">
          <div>我的工资</div>
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="earningBox">
        <div class="earning-item border-right border-bottom">
          <div>{{ statistics.today / 100}}</div>
          <div class="earning-title">今日收入</div>
        </div>
        <div class="earning-item border-bottom">
          <div>{{ statistics.yesterday / 100}}</div>
          <div class="earning-title">昨日收入</div>
        </div>
        <div class="earning-item border-right">
          <div>{{ statistics.thisWeek / 100}}</div>
          <div class="earning-title">本周收入</div>
        </div>
        <div class="earning-item border-right">
          <div>{{ statistics.lastWeek / 100}}</div>
          <div class="earning-title">上周收入</div>
        </div>
        <div class="earning-item border-right border-bottom">
          <div>{{ statistics.total / 100}}</div>
          <div class="earning-title">累计收入</div>
        </div>
      </div>
    </div>


    <van-row class="grid">
      <van-col span="8">
        <router-link class="item van-hairline--bottom van-hairline--right" to="/article/list?type=2">
          <van-icon color="var(--primary-color)" name="description" size="30px"/>
          <div class="text">店员手册</div>
        </router-link>
      </van-col>
      <van-col v-if="$ClerkAccess.includes('random')" span="8">
        <router-link class="item van-hairline--bottom van-hairline--right" to="/clerk/random">
          <van-icon color="var(--primary-color)" name="orders-o" size="30px"/>
          <div class="text">抢单大厅</div>
        </router-link>
      </van-col>
<!--      <template v-if="$store.state.shop.id != 19">-->
<!--        <van-col span="8">-->
<!--          <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/ranking-list">-->
<!--            <van-icon color="var(&#45;&#45;primary-color)" name="chart-trending-o" size="30px"/>-->
<!--            <div class="text">我的排名</div>-->
<!--          </router-link>-->
<!--        </van-col>-->
<!--      </template>-->
<!--      <van-col span="8">-->
<!--        <router-link class="item van-hairline&#45;&#45;bottom van-hairline&#45;&#45;right" to="/clerk/grade">-->
<!--          <van-icon color="var(&#45;&#45;primary-color)" name="label-o" size="30px"/>-->
<!--          <div class="text">我的等级</div>-->
<!--        </router-link>-->
<!--      </van-col>-->
      <van-col v-if="$ClerkAccess.includes('reward-log')" span="8">
        <router-link class="item van-hairline--bottom " to="/clerk/reward-log">
          <van-icon color="var(--primary-color)" name="point-gift-o" size="30px"/>
          <div class="text">打赏动态</div>
        </router-link>
      </van-col>
      <!--    开放动态广场    -->
      <van-col v-if="$hasFeature('post_list') && $ClerkAccess.includes('post-list')" span="8">
        <router-link class="item van-hairline--right" to="/clerk/post/list">
          <van-icon color="var(--primary-color)" name="chat-o" size="30px"/>
          <div class="text">发布动态</div>
        </router-link>
      </van-col>
      <van-col v-if="$hasFeature('auto_online') && $ClerkAccess.includes('auto-online')" span="8">
        <router-link class="item van-hairline--right" to="/clerk/auto/online">
          <van-icon color="var(--primary-color)" name="underway-o" size="30px"/>
          <div class="text">自动在线</div>
        </router-link>
      </van-col>
    </van-row>

    <div class="return" @click="back">
      <van-icon name="arrow-left" size="16px"/>
      <div>返回</div>
    </div>

    <tabbar></tabbar>
  </div>
</template>

<script>
import tabbar from "@/views/clerk/tabbar";
import Vue from 'vue';
import {Cell, CellGroup, Col, Dialog, Icon, Row, Switch, Toast} from 'vant';
import {getStatisticsInfo} from '@/api/clerk/clerk'


Vue.use(Row)
    .use(Col)
    .use(Icon)
    .use(CellGroup)
    .use(Cell)
    .use(Switch)
    .use(Dialog)
    .use(Toast)

export default {
  name: "clerk-houtai",
  components:{
    tabbar
  },

  data(){
    return {
      statistics: {
        today: null,
        yesterday: null,
        thisWeek: null,
        lastWeek: null,
        total: null,
      }
    }
  },

  methods:{
    back(){
      this.$router.push('/')
    },

    getStatisticsInfo(){
      Toast.loading({
        mask: true,
        message: '请稍候'
      })

      getStatisticsInfo().then(res => {
        Toast.clear()
        this.statistics = res.data
      })
    },

    pushWages(){
      this.$router.push("/clerk/wages")
    }
  },

  mounted() {
    this.getStatisticsInfo()
  }


}
</script>

<style lang="less" scoped>

.earning{
  margin: 0 10px 0;
  background: #fff;
  color: var(--primary-color);
  background: var(--primary-color);
  border-radius: 10px;

  .earningBox{
    display: flex;
    flex-wrap: wrap;
    border-radius: 0 0 8px 8px;
  }

  .watch{
    padding: 10px 15px 10px;
    position: relative;
    //border-bottom: 1px solid #fff;

    &::after{
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #fff;
      transform: scaleY(.5);
    }

    .watchClick{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
    }
  }



  //.border-right{
  //  border-right: 1px solid var(--primary);
  //
  //}
  //
  //.border-bottom{
  //  border-bottom: 1px solid var(--primary);
  //}

  .earning-item{
    width: 20%;
    box-sizing: border-box;
    display: flex;
    padding: 10px 0 10px;
    flex-direction: column;
    align-items: center;
    border-collapse:collapse;
    color: #fff;


    .earning-title{
      //color: #333;
      margin-top: 5px;
    }
  }
}

.grid {
  margin: 20px 10px 0;
  background: #fff;
  border-radius: 15px;


  .item {
    display: block;
    padding: 20px 0;
    text-align: center;

    &:active {
      background: #e5e5e5;
    }

    .icon {

    }

    .text {
      color: #333;
      font-size: 14px;
      margin-top: 6px;
    }

  }

}

.return{
  position: fixed;
  bottom: 68px;
  left: 21px;
  display: flex;
  align-items: center;
  border-radius: 50%;
  background: var(--primary-color);
  width: 50px;
  height: 50px;
  color: #fff;
}



</style>
